// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IEmissionCertificateType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class EmissionCertificateType implements IEmissionCertificateType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Vehicle Inspection Report EmissionCertificateType
	**/
    get VehicleInspectionReport(): IEmissionCertificateType {
        return this.FromId(5);
    }
    /**
		Returns Waiver EmissionCertificateType
	**/
    get Waiver(): IEmissionCertificateType {
        return this.FromId(10);
    }
    /**
		Returns Director's Certificate EmissionCertificateType
	**/
    get DirectorsCertificate(): IEmissionCertificateType {
        return this.FromId(15);
    }
    /**
		Returns Certificate of Inspection EmissionCertificateType
	**/
    get CertificateOfInspection(): IEmissionCertificateType {
        return this.FromId(20);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('5', { id: 5, value: 'VehicleInspectionReport', displayValue: 'Vehicle Inspection Report', description: 'Vehicle Inspection Report', sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, value: 'Waiver', displayValue: 'Waiver', description: 'Waiver', sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, value: 'DirectorsCertificate', displayValue: 'Director\'s Certificate', description: 'Director\'s Certificate', sortOrder: 999999, active: true });
        this._dictionary.add('20', { id: 20, value: 'CertificateOfInspection', displayValue: 'Certificate of Inspection', description: 'COI - issued by an Auto Dealer', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IEmissionCertificateType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IEmissionCertificateType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IEmissionCertificateType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IEmissionCertificateType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IEmissionCertificateType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
